module.exports = __webpack_public_path__ + "img/Flag_of_Bulgaria.bb7d1929.svg";